module.exports = __webpack_public_path__ + "static/media/banner_mercedes.611bb23b.jpg";